module.exports = __webpack_public_path__ + "img/logo_text.d74c1106.png";